// 这个文件是路由配置相关配置

import { CallbackUrl } from "@/services/callback";

/**
 * 授权认证相关页面 基础路径列表
 */
export const AuthBaseRoutePath: string[] = ["/login", "/appKeyLogin", "/register/independentManual", "/logout"];

/**
 * 订单管理相关 基础路径列表
 */
export const OMSBaseRoutePath: string[] = [
    "/order/list",
    "/order/refund",
    "/manualOrder",
    "/order/search",
    "/merchantsCancelEwaybills",
];

/**
 * 回调相关 基础路径列表
 * 详情见 @see CallBackRoutes.tsx
 */
export const CallbackBaseRoutePath: string[] = [
    // TODO: 废弃，后续删除此链接
    "/pddVerifyAuthCallback",
    "/paymentResult",

    // 下面需要保留
    "/router",
    "/redirect",
    "/callback",
];

/**
 * 订购升级相关路由 基础路径列表
 * 详情见 @see SubscriptionRoutes.tsx
 */
export const SubscriptionBaseRoutePath: string[] = [
    // TODO: 废弃，后续删除此链接
    "/ecMarketShopSubscription",
    "/renewal",
    "/renewConfirm",

    // 下面需要保留
    "/subscription",
];

/**
 * 登录到发货易需要获取用户信息的基础路由
 *
 * 优先级高于 @see isNotLoadUserInfoDataBaseRoutePaths
 */
const isShouldLoadUserInfoDataBaseRoutePaths = [CallbackUrl.PDD_VERIFY_AUTH];

/**
 * 登录到发货易不需要获取用户信息的基础路由
 */
const isNotLoadUserInfoDataBaseRoutePaths = [
    "/login",
    "/logout",
    "/register/independentManual",
    "/partnership/login",
    "/partnership/register",
    "/callback",
    "/redirect",
    "/appKeyLogin",
    "/cs",
    "/renewConfirm", // TODO: 废弃，后续删除此链接
    "/subscription/renewal/confirm",
    "/subscription/renewal/confirm-v2",
];

/**
 * 判断打开发货易页面时，是否需要请求获取用户数据
 */
export function getIsNeedLoadData(pathname: string) {
    const isNeedLoadData = isShouldLoadUserInfoDataBaseRoutePaths.find((route) => pathname.startsWith(route));

    if (isNeedLoadData) {
        return true;
    }

    return !isNotLoadUserInfoDataBaseRoutePaths.find((route) => pathname.startsWith(route));
}

/**
 * 是否仅显示基础UI框架
 *
 * 背景白色，无导航栏
 */
const onlyShowBaseLayoutBaseRoutePaths = [
    "/setting/waybillTemplate/edit",
    "/setting/packingListTemplate/edit",
    "/setting/orderItemLabelTemplate/edit",
    "/features/product-label-template/edit",
    "/features/product-label-template/create",
    "/redirect",
    "/ecMarketShopSubscription", // TODO: 废弃，后续删除此链接
    "/subscription/expired",
    "/subscription/order/list",
    "/setting/user/updatePhoneBinding",
];

/**
 * 是否仅显示基础Layout样式
 */
export function getOnlyShowBaseLayout(pathname: string) {
    return onlyShowBaseLayoutBaseRoutePaths.some((it) => location.pathname.startsWith(it));
}

/**
 * 是否隐藏导航栏的
 */
const hideTopLayoutBaseRoutePaths = [
    "/login",
    "/logout",
    "/partnership/register",
    "/callback",
    "/appKeyLogin",
    "/cs",
    "/register/independentManual",
    "/renewConfirm", // TODO: 废弃，后续删除此链接
    "/subscription/renewal/confirm",
    "/subscription/renewal/confirm-v2",
    "/setting/user/updatePhoneBinding",
];

/**
 * 获取当前路由是否需要隐藏顶部UI样式
 *
 * 优先级高于 @see getOnlyShowBaseLayout
 */
export function getIsHideTopLayout(pathname: string) {
    return hideTopLayoutBaseRoutePaths.some((it) => location.pathname.indexOf(it) > -1);
}
